import type { CurrentUserQuery } from '../graphql';

export type UserOrgRight =
  | 'orgAdmin'
  | 'createAndEditOrders'
  | 'createAndEditVoyages'
  | 'createAndEditContracts'
  | 'accessFinancialData'
  | 'createAndEditPortCalls'
  | 'createAndEditCargoMeasurement'
  | 'accessCargoMeasurement'
  | 'createAndEditBillOfLading'
  | 'accessBillOfLading';

export const getCurrentUserRightsByOrgId = (
  userRights: NonNullable<CurrentUserQuery['currentUser']>['userRights'],
): Map<number, Record<UserOrgRight, boolean>> => {
  const map = new Map<number, Record<UserOrgRight, boolean>>();

  userRights.nodes.forEach((userRights) => {
    if (!userRights) return;

    userRights.organizationByOrganizationId?.descendants?.forEach((orgId) => {
      if (typeof orgId !== 'number') return;

      const existingRights = map.get(orgId);

      const currentOrExistingRight = (right: UserOrgRight): boolean =>
        userRights[right] || (existingRights?.[right] ?? false);

      map.set(orgId, {
        accessFinancialData: currentOrExistingRight('accessFinancialData'),
        createAndEditContracts: currentOrExistingRight(
          'createAndEditContracts',
        ),
        createAndEditOrders: currentOrExistingRight('createAndEditOrders'),
        createAndEditPortCalls: currentOrExistingRight(
          'createAndEditPortCalls',
        ),
        createAndEditVoyages: currentOrExistingRight('createAndEditVoyages'),
        orgAdmin: currentOrExistingRight('orgAdmin'),
        accessBillOfLading: currentOrExistingRight('accessBillOfLading'),
        createAndEditBillOfLading: currentOrExistingRight(
          'createAndEditBillOfLading',
        ),
        accessCargoMeasurement: currentOrExistingRight(
          'accessCargoMeasurement',
        ),
        createAndEditCargoMeasurement: currentOrExistingRight(
          'createAndEditCargoMeasurement',
        ),
      });
    });
  });

  return map;
};
